"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreationState = void 0;
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const CreativeFormat_1 = require("./CreativeFormat");
const OfferPricingDetails_1 = require("./CreativeFormat/OfferPricingDetails");
const Deliverable_1 = require("./Deliverable");
const ModificationRequest_1 = require("./ModificationRequest");
const Organization_1 = require("./Organization");
const User_1 = require("./User");
class Creation {
    constructor({ id, assignmentId, projectId, creationSetId, number, assignee, creativeFormat, deliverables, latestDeliverableUrl, latestDeliverableSubmittedAt, latestProposedDeliverable, modificationRequests, modificationRequestFreeExpiredAt, modificationRequestExpired, modificationRequestPoint, modificationRequestFreeLimit, isNextModificationRequestForAFee, inspectionModificationRequests, state, proposed, createdAt, submittedAt, stateUpdatedAt, screeningDueDate, organization, offerPricingDetails, achievementId, finalized, modReqDeliveryScheduleDate, }) {
        this.toJSON = () => {
            const res = {
                id: this.id,
                number: this.number,
                state: this.state,
                proposed: this.proposed,
                latestDeliverableUrl: this.latestDeliverableUrl,
                modificationRequestPoint: this.modificationRequestPoint,
                modificationRequestFreeLimit: this.modificationRequestFreeLimit,
                modificationRequestExpired: this.modificationRequestExpired,
                offerPricingDetails: this.offerPricingDetails,
                achievementId: this.achievementId,
            };
            res.assignee = this.assignee && this.assignee.toJSON();
            res.creativeFormat = this.creativeFormat && this.creativeFormat.toJSON();
            res.deliverables = this.deliverables && this.deliverables.toJSON();
            res.latestProposedDeliverable = this.latestProposedDeliverable && this.latestProposedDeliverable.toJSON();
            res.modificationRequests = this.modificationRequests && this.modificationRequests.toJSON();
            res.modificationRequestFreeExpiredAt =
                this.modificationRequestFreeExpiredAt && this.modificationRequestFreeExpiredAt.toISO();
            res.isNextModificationRequestForAFee =
                this.isNextModificationRequestForAFee && this.isNextModificationRequestForAFee;
            res.inspectionModificationRequests =
                this.inspectionModificationRequests && this.inspectionModificationRequests.toJSON();
            res.createdAt = this.createdAt && this.createdAt.toISO();
            res.submittedAt = this.submittedAt && this.submittedAt.toISO();
            res.stateUpdatedAt = this.stateUpdatedAt && this.stateUpdatedAt.toISO();
            res.screeningDueDate = this.screeningDueDate && this.screeningDueDate.toISO();
            res.organization = this.organization && this.organization.toJSON();
            return res;
        };
        this.id = id;
        this.assignmentId = assignmentId;
        this.projectId = projectId;
        this.creationSetId = creationSetId;
        this.number = number;
        this.assignee = assignee;
        this.creativeFormat = creativeFormat;
        this.deliverables = deliverables;
        this.latestDeliverableUrl = latestDeliverableUrl;
        this.latestDeliverableSubmittedAt = latestDeliverableSubmittedAt;
        this.latestProposedDeliverable = latestProposedDeliverable;
        this.modificationRequests = modificationRequests;
        this.modificationRequestFreeExpiredAt = modificationRequestFreeExpiredAt;
        this.modificationRequestExpired = modificationRequestExpired;
        this.modificationRequestPoint = modificationRequestPoint;
        this.modificationRequestFreeLimit = modificationRequestFreeLimit;
        this.isNextModificationRequestForAFee = isNextModificationRequestForAFee;
        this.inspectionModificationRequests = inspectionModificationRequests;
        this.state = state;
        this.proposed = proposed;
        this.createdAt = createdAt;
        this.submittedAt = submittedAt;
        this.stateUpdatedAt = stateUpdatedAt;
        this.screeningDueDate = screeningDueDate;
        this.organization = organization;
        this.offerPricingDetails = offerPricingDetails;
        this.achievementId = achievementId;
        this.finalized = finalized;
        this.modReqDeliveryScheduleDate = modReqDeliveryScheduleDate;
    }
    get latestDeliverable() {
        if (!this.deliverables) {
            return;
        }
        return this.deliverables.sort((a, b) => b.createdAt.valueOf() - a.createdAt.valueOf()).first();
    }
    get modificationRequestsWithoutDraft() {
        if (!this.modificationRequests) {
            return immutable_1.List();
        }
        return this.modificationRequests.filter(modificationRequest => modificationRequest.state !== 'draft');
    }
    latestModificationRequest(deliverable) {
        if (!this.modificationRequests) {
            return;
        }
        return this.modificationRequests.findLast(modificationRequest => modificationRequest.targetDeliverableId === deliverable.id);
    }
}
Creation.fromJSON = (json) => {
    const obj = Object.assign({}, json);
    const { id, assignmentId, projectId, creationSetId, number, assignee, creativeFormat, deliverables, latestDeliverableUrl, latestDeliverableSubmittedAt, latestProposedDeliverable, modificationRequests, modificationRequestFreeExpiredAt, modificationRequestExpired, modificationRequestPoint, modificationRequestFreeLimit, isNextModificationRequestForAFee, inspectionModificationRequests, state, proposed, createdAt, submittedAt, stateUpdatedAt, screeningDueDate, organization, offerPricingDetails, achievementId, finalized, modReqDeliveryScheduleDate, } = obj;
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (assignmentId !== undefined && typeof assignmentId !== 'string')
        throw new Error('.assignmentId must be a string');
    if (projectId !== undefined && typeof projectId !== 'string')
        throw new Error('.projectId must be a string');
    if (creationSetId !== undefined && typeof creationSetId !== 'string')
        throw new Error('.creationSetId must be a string');
    if (number !== undefined && !Number.isSafeInteger(number))
        throw new Error('.number must be an integer');
    if (deliverables !== undefined && !Array.isArray(deliverables))
        throw new Error('.deliverables must be an array');
    if (latestDeliverableUrl !== undefined && typeof latestDeliverableUrl !== 'string')
        throw new Error('.latestDeliverableUrl must be a string');
    if (latestDeliverableSubmittedAt !== undefined && typeof latestDeliverableSubmittedAt !== 'string')
        throw new Error('.latestDeliverableSubmittedAt must be a string');
    if (modificationRequests !== undefined && !Array.isArray(modificationRequests))
        throw new Error('.modificationRequests must be an array');
    if (modificationRequestFreeExpiredAt !== undefined &&
        modificationRequestFreeExpiredAt !== null &&
        typeof modificationRequestFreeExpiredAt !== 'string')
        throw new Error('.modificationRequestFreeExpiredAt must be a string');
    if (modificationRequestPoint !== undefined && !Number.isSafeInteger(modificationRequestPoint))
        throw new Error('.modificationRequestPoint must be an integer');
    if (modificationRequestFreeLimit !== undefined && !Number.isSafeInteger(modificationRequestFreeLimit))
        throw new Error('.modificationRequestFreeLimit must be an integer');
    if (isNextModificationRequestForAFee !== undefined && typeof isNextModificationRequestForAFee !== 'boolean')
        throw new Error('.isNextModificationRequestForAFee must be a boolean');
    if (inspectionModificationRequests !== undefined && !Array.isArray(inspectionModificationRequests))
        throw new Error('.inspectionModificationRequests must be an array');
    if (state !== undefined && typeof state !== 'string')
        throw new Error('.state must be a string');
    if (proposed !== undefined && typeof proposed !== 'boolean')
        throw new Error('.proposed must be a boolean');
    if (createdAt !== undefined && typeof createdAt !== 'string')
        throw new Error('.createdAt must be a string');
    if (!!submittedAt && typeof submittedAt !== 'string')
        throw new Error('.submittedAt must be a string');
    if (stateUpdatedAt !== undefined && typeof stateUpdatedAt !== 'string')
        throw new Error('.stateUpdatedAt must be a string');
    if (modificationRequestExpired !== undefined && typeof modificationRequestExpired !== 'boolean')
        throw new Error('.modificationRequestExpired must be a boolean');
    if (achievementId !== undefined && achievementId !== null && typeof achievementId !== 'string')
        throw new Error('.achievementId must be a string');
    if (finalized !== undefined && typeof finalized !== 'boolean')
        throw new Error('.finalized must be a boolean');
    if (modReqDeliveryScheduleDate !== undefined && typeof modReqDeliveryScheduleDate !== 'string')
        throw new Error('.modReqDeliveryScheduleDate must be a string');
    const _assignee = assignee ? User_1.OptimizerUser.fromJSON(assignee) : undefined;
    const _creativeFormat = creativeFormat ? CreativeFormat_1.default.fromJSON(creativeFormat) : undefined;
    const _deliverables = deliverables ? immutable_1.List(deliverables).map(item => Deliverable_1.default.fromJSON(item)) : undefined;
    const _latestProposedDeliverable = latestProposedDeliverable
        ? Deliverable_1.default.fromJSON(latestProposedDeliverable)
        : undefined;
    const _modificationRequests = modificationRequests
        ? immutable_1.List(modificationRequests).map(item => ModificationRequest_1.default.fromJSON(item))
        : undefined;
    const _latestDeliverableSubmittedAt = latestDeliverableSubmittedAt
        ? luxon_1.DateTime.fromISO(latestDeliverableSubmittedAt)
        : undefined;
    const _modificationRequestFreeExpiredAt = modificationRequestFreeExpiredAt
        ? luxon_1.DateTime.fromISO(modificationRequestFreeExpiredAt)
        : undefined;
    const _inspectionModificationRequests = inspectionModificationRequests
        ? immutable_1.List(inspectionModificationRequests)
        : undefined;
    const _state = state ? deserializeToCreationState(state) : undefined;
    const _createdAt = createdAt ? luxon_1.DateTime.fromISO(createdAt) : undefined;
    const _submittedAt = submittedAt ? luxon_1.DateTime.fromISO(submittedAt) : undefined;
    const _stateUpdatedAt = stateUpdatedAt ? luxon_1.DateTime.fromISO(stateUpdatedAt) : undefined;
    const _screeningDueDate = screeningDueDate ? luxon_1.DateTime.fromISO(screeningDueDate) : undefined;
    const _organization = organization ? Organization_1.default.fromJSON(organization) : undefined;
    const _offerPricingDetails = offerPricingDetails ? OfferPricingDetails_1.default.fromJSON(offerPricingDetails) : undefined;
    const _modReqDeliveryScheduleDate = modReqDeliveryScheduleDate
        ? luxon_1.DateTime.fromISO(modReqDeliveryScheduleDate)
        : undefined;
    return new Creation({
        id,
        assignmentId,
        projectId,
        creationSetId,
        number,
        assignee: _assignee,
        creativeFormat: _creativeFormat,
        deliverables: _deliverables,
        latestDeliverableUrl,
        latestDeliverableSubmittedAt: _latestDeliverableSubmittedAt,
        latestProposedDeliverable: _latestProposedDeliverable,
        modificationRequests: _modificationRequests,
        modificationRequestFreeExpiredAt: _modificationRequestFreeExpiredAt,
        modificationRequestExpired,
        modificationRequestPoint,
        modificationRequestFreeLimit,
        isNextModificationRequestForAFee,
        inspectionModificationRequests: _inspectionModificationRequests,
        state: _state,
        proposed,
        createdAt: _createdAt,
        submittedAt: _submittedAt,
        stateUpdatedAt: _stateUpdatedAt,
        screeningDueDate: _screeningDueDate,
        organization: _organization,
        offerPricingDetails: _offerPricingDetails,
        achievementId,
        finalized,
        modReqDeliveryScheduleDate: _modReqDeliveryScheduleDate,
    });
};
const deserializeToCreationState = (str) => {
    if (Object.keys(exports.CreationState).indexOf(str) === -1) {
        throw new Error(`str must be a one of ${Object.keys(exports.CreationState).join(', ')}`);
    }
    return str;
};
exports.CreationState = {
    in_progress: 'in_progress',
    in_inspection: 'in_inspection',
    inspection_modification_requested: 'inspection_modification_requested',
    in_proposal: 'in_proposal',
    submitted: 'submitted',
    modification_requested: 'modification_requested',
    approved: 'approved',
    canceled: 'canceled',
};
exports.default = Creation;
